// App.js ou LayoutProtegido.jsx
import { ButtonAction } from "../components/ButtonsActions/ButtonAction";
import { ModalGeneric } from "../components/ModalGeneric";
import { useSessionCheck } from "../hooks/useSessionCheck";
import { logout } from "../services/auth";
import { BoxGrid, P } from "../shared/GlobalStyles/styles";

export default function RoutesSessionLogin({ children }) {
  const logoutUser = () => logout('LOGIN')
  const {closeModalRedirect, isVisibleRedirectLogin} = useSessionCheck(logoutUser);

  return (
      <>
        {
            children
        }
        {
            isVisibleRedirectLogin && (
                    <ModalGeneric.Root close={closeModalRedirect} width={'30%'} height={'30%'}>
                      <ModalGeneric.Header Title={'Sessão expirada'} onClose={closeModalRedirect}/>
                        <ModalGeneric.Body>
                            <BoxGrid>
                                <P>Sua sessão expirou. Logue novamente por favor!</P>

                            </BoxGrid>
                
                        </ModalGeneric.Body>
                               <ModalGeneric.Footer>
                                        <ButtonAction
                                            width={'132px'}
                                            height={'48px'} 
                                            fontWeight={'600'}
                                            variant={1}
                                            onClick={closeModalRedirect}        
                                        >
                                            Voltar
                                        </ButtonAction>
                                    </ModalGeneric.Footer>
                    </ModalGeneric.Root>
            )
        }
    </>
  );
}
